import React from "react";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography";

import "@/shared/ui/data-display/tags/style/tag-content.scss";

export interface TagContentProps {
    tag: string;
    icon?: string;
    active?: boolean;
    onClick?: () => void;
    className?: string;
    nav_id?: string;
}

export const TagContent: React.FC<TagContentProps> = ({tag, icon, onClick, className = "", nav_id}) => {
    return (
        <a href={`#${nav_id}`} className={`tag-content ${className}`} onClick={onClick} type="button">
            {icon && (
                <span className="tag-content__icon">
                    <SmartImage src={icon} alt={tag} width={16} height={16} />
                </span>
            )}
            <Typography as="span" size={{desktop: 16, mobile: 14}} weight={500} className="tag-content__text">
                {tag}
            </Typography>
        </a>
    );
};
